import { defineStore } from "pinia";

export const useNotifyStore = defineStore("notify", {
  state: () => ({
    notificationsInitialized: false,
    newNotifications: {
      new_likes_notifications: 0,
      new_messages_notifications: 0,
      new_matches_notifications: 0,
    },
  }),
  getters: {
    isNotificationsInitialized: (state) => state.notificationsInitialized,
    getNotifications: (state) => state.newNotifications,
  },
  actions: {
    setNotifications(newNotifications) {
      this.newNotifications = newNotifications;
    },
    setNotificationsInitialized() {
      this.notificationsInitialized = true;
    },
  },
});
